import { render, staticRenderFns } from "./NextDrawInfo.vue?vue&type=template&id=58186be6&scoped=true"
import script from "./NextDrawInfo.vue?vue&type=script&lang=js"
export * from "./NextDrawInfo.vue?vue&type=script&lang=js"
import style0 from "./NextDrawInfo.vue?vue&type=style&index=0&id=58186be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58186be6",
  null
  
)

export default component.exports